module.exports = __webpack_public_path__ + "media/images/riders/small/TROY_BROSNAN-afb7797af551cbbad6c51b517258fda7.png";